<div class="center" style="display: flex;">
    <section class="error">
      <h1 class="error__title" style="color: red ; font-size: 200px;">404</h1>
      <!-- <p class="error__cta">We’re sorry, the page you have looked for does not exist in our database! Maybe go to our <a class="error__link error__link--purple" href="#" target="_blank">home page</a> or try to use a <a class="error__link error__link--blue" href="#" target="_blank">search?</a></p> -->
    </section>
    <section class="error">
        <h2 class="error__title" style="color: red ; font-size: 50px;">Page Not Fuund</h2>
      </section>

  </div>

  
